/**
 * Oracle Object Dialog Store
 *
 * Manages open/close state for CREATE and ALTER dialogs for
 * Oracle-specific objects (sequences, synonyms, DB links).
 */

import { create } from 'zustand';

type DialogType = 'create-sequence' | 'create-synonym' | 'create-dblink' | 'alter-sequence';

type DialogContext = {
  connectionId: string;
  schema: string;
  database: string;
};

type AlterSequenceContext = DialogContext & {
  objectName: string;
  incrementBy: number;
  minValue: string;
  maxValue: string;
  cacheSize: number;
  cycle: boolean;
  order: boolean;
};

type OracleObjectDialogState = {
  openDialog: DialogType | null;
  context: DialogContext | null;
  alterSequenceContext: AlterSequenceContext | null;

  openCreateSequence: (ctx: DialogContext) => void;
  openCreateSynonym: (ctx: DialogContext) => void;
  openCreateDbLink: (ctx: DialogContext) => void;
  openAlterSequence: (ctx: AlterSequenceContext) => void;
  close: () => void;
};

export const useOracleObjectDialogStore = create<OracleObjectDialogState>((set) => ({
  openDialog: null,
  context: null,
  alterSequenceContext: null,

  openCreateSequence: (ctx) => set({ openDialog: 'create-sequence', context: ctx }),
  openCreateSynonym: (ctx) => set({ openDialog: 'create-synonym', context: ctx }),
  openCreateDbLink: (ctx) => set({ openDialog: 'create-dblink', context: ctx }),
  openAlterSequence: (ctx) => set({ openDialog: 'alter-sequence', context: ctx, alterSequenceContext: ctx }),
  close: () => set({ openDialog: null, context: null, alterSequenceContext: null }),
}));
